import { key } from './LocalStorage';
import { getSession } from './Session';

export const roles = {
	SuperUser: 'superuser',
	Automation: 'automation',
	UserAdmin: 'useradmin',
	ExternalUser: 'externaluser',
	Sysadmin: 'sysadmin',
	SelfService: 'selfservice',
	CustomCategoryAdmin: 'categoryadmin',
	PreviewFeatures: 'previewfeatures',
	OgmAi: 'ogmai',
	OgmAiTrial: 'ogmaitrial',

	isSuperUser: () => {
		return getRoles().indexOf(roles.SuperUser) !== -1;
	},
	isUserAdmin: () => {
		return getRoles().indexOf(roles.UserAdmin) !== -1;
	},
	isExternalUser: () => {
		return getRoles().indexOf(roles.ExternalUser) !== -1;
	},
	isSelfService: () => {
		return getRoles().indexOf(roles.SelfService) !== -1;
	},
	isSysAdmin: () => {
		return getRoles().indexOf(roles.Sysadmin) !== -1;
	},
	isCustomCategoryAdmin: () => {
		return getRoles().indexOf(roles.CustomCategoryAdmin) !== -1;
	},
	isPreviewFeatureUser: () => {
		return getRoles().indexOf(roles.PreviewFeatures) !== -1;
	},
	isOgmAiUser: () => {
		return getRoles().indexOf(roles.OgmAi) !== -1;
	},
	isOgmAiTrialUser: () => {
		return getRoles().indexOf(roles.OgmAiTrial) !== -1;
	},
};

export const getRoleDescription = (role: string) => {
	switch (role) {
		case roles.SuperUser: {
			return 'Read / Write';
		}
		case roles.Automation: {
			return 'Automation';
		}
		case roles.UserAdmin: {
			return 'User Admin';
		}
		case roles.ExternalUser: {
			return 'External User';
		}
		case roles.Sysadmin: {
			return 'System Admin';
		}
		case roles.SelfService: {
			return 'Manage Customers';
		}
		case roles.CustomCategoryAdmin: {
			return 'Custom Category Admin';
		}
		case roles.OgmAi: {
			return 'OGM AI';
		}
		case roles.OgmAiTrial: {
			return 'OGM AI Trial';
		}
		case roles.PreviewFeatures: {
			return 'Preview Features';
		}
		default: {
			return '';
		}
	}
};

export const isSuperUser = roles.isSuperUser;

export const canCreateBlueprint = () => {
	return roles.isSuperUser();
};

export const canDeleteBlueprint = () => {
	return roles.isSuperUser();
};

export const canCreateMasterItem = () => {
	return roles.isSuperUser();
};

export const canCreateMassChangeRequests = () => {
	return roles.isSuperUser();
};

export const canEditMasterItem = () => {
	return roles.isSuperUser();
};

export const canManageRestrictions = () => {
	return roles.isSuperUser();
};

export const canEditRestrictionLists = () => {
	return roles.isSuperUser();
};

export const canEditLocations = () => {
	return roles.isSuperUser();
};

export const canEditUsers = () => {
	return roles.isUserAdmin();
};

export const canManageCustomers = () => {
	return roles.isSelfService();
};

export const canManageCustomCategories = () => {
	return roles.isCustomCategoryAdmin();
};

export const canManageAiSettings = () => {
	return roles.isOgmAiUser();
};

export const canViewAiFeatures = () => {
	return roles.isOgmAiUser() || roles.isOgmAiTrialUser();
};

export const isProcurementServicesUser = () => {
	return window.localStorage.getItem(key.userProfileId) === '6';
};

export const getRoles = () => {
	const rolesJson = window.localStorage.getItem('ogm:roles');
	const userRoles = rolesJson ? JSON.parse(rolesJson) : [];
	return userRoles as string[];
};

export function setUserDefaultPageSize(pageSize: number) {
	window.localStorage.setItem(key.userDefaultPageSize, pageSize.toString());
}

export function getUserDefaultPageSize() {
	const pageSize = +window?.localStorage?.getItem(key.userDefaultPageSize);
	return pageSize ? pageSize : 20;
}

export function isSyscoSiteType() {
	const session = getSession();
	const hasSyscoSiteType = session.siteTypeId;
	return hasSyscoSiteType === 1;
}

export function isDssiSiteType() {
	const session = getSession();
	const hasDssiSiteType = session.siteTypeId;
	return hasDssiSiteType === 2;
}
